module.exports = __webpack_public_path__ + "static/media/B_F01.078f8c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_F01.png
// module id = 115
// module chunks = 0